import type { StatementDataColumnConfiguration } from "../../../../../../../api/types/svTypes.ts";

export const DATA_COLUMN_LABEL = "Amount";
export const FORMULA_COLUMN_LABEL = "Calculated Column";

type TypedColumn = Pick<StatementDataColumnConfiguration, "columnType">;

export const isDataColumn = (column: TypedColumn): boolean => column.columnType === "Data";

export const hasSingleDataColumn = (dataColumns: TypedColumn[]): boolean =>
  dataColumns.filter(isDataColumn).length === 1;

export const getDefaultColumnLabel = (isFormula: boolean): string =>
  isFormula ? FORMULA_COLUMN_LABEL : DATA_COLUMN_LABEL;

export const getDataColumnLabel = (column: Pick<StatementDataColumnConfiguration, "columnType" | "customLabel">): string =>
  column.customLabel?.trim() || getDefaultColumnLabel(!isDataColumn(column));
